import moment from "moment-timezone";
import { i18n } from "@/i18n";

const t = (key, params) => i18n.t("broadcast.customers." + key, params);

// "N ชม. ที่แล้ว" / "เมื่อวาน" / "N วันที่แล้ว" from an ISO time; "" when absent
export const relativeTime = (iso, now = Date.now()) => {
  const ms = iso ? new Date(iso).getTime() : NaN;
  if (isNaN(ms)) return "";
  const hours = Math.max(0, now - ms) / 3600000;
  if (hours < 24) return t("hours_ago", { n: Math.max(1, Math.floor(hours)) });
  const days = Math.floor(hours / 24);
  return days === 1 ? t("yesterday") : t("days_ago", { n: days });
};

// "ทัก N ครั้ง · time"
export const customerMeta = (count, iso) => {
  const head = t("sent_count", { n: Number(count || 0).toLocaleString("en-US") });
  const when = relativeTime(iso);
  return when ? head + " · " + when : head;
};

// 14:05 (Bangkok), for the chat bubbles
export const clock = (iso) => {
  const m = moment(iso);
  return m.isValid() ? m.tz("Asia/Bangkok").format("HH:mm") : "";
};

